import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

export const PackChatRefreshError = ({ onRetry }: { onRetry?: () => void }) => (
  <Stack fullWidth gap="xs" role="alert">
    <Typography variant="bodyW3" textColor="secondary">
      Could not refresh the conversation. Your draft is saved here. New messages
      may be missing.
    </Typography>
    {onRetry && (
      <Button variant="secondary" size="sm" onClick={onRetry}>
        Try again
      </Button>
    )}
  </Stack>
);
